/**
 * Dismissed flag for the "back to the old dashboard" banner.
 *
 * Mirrors the old frontend's `lib/v2BannerState.ts` (which gates the opt-*in*
 * banner there): `localStorage` for persistence plus a custom `window` event so
 * every subscriber in the tab re-renders together, since `storage` only fires
 * in *other* tabs.
 */

const KEY = 'retraced:oldDashboardBannerDismissed';
const EVENT = 'retraced:oldDashboardBannerDismiss';

export function isOldDashboardBannerDismissed(): boolean {
  try {
    return localStorage.getItem(KEY) === 'true';
  } catch {
    // Private mode / storage disabled — show the banner rather than crash.
    return false;
  }
}

export function setOldDashboardBannerDismissed(dismissed: boolean): void {
  try {
    if (dismissed) localStorage.setItem(KEY, 'true');
    else localStorage.removeItem(KEY);
  } catch {
    // Ignore: the event below still syncs this tab for the session.
  }
  window.dispatchEvent(new Event(EVENT));
}

export function subscribeOldDashboardBannerDismiss(
  onChange: () => void,
): () => void {
  window.addEventListener(EVENT, onChange);
  return () => window.removeEventListener(EVENT, onChange);
}
